// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingPage_root__FRxBl","backgroundColor-light":"LoadingPage_backgroundColor-light__Wj5s8","backgroundColor-lightGray":"LoadingPage_backgroundColor-lightGray__9tKFY"};